import { render, staticRenderFns } from "./companychecksetting.html?vue&type=template&id=06abcd1e&scoped=true&external"
import script from "./companychecksetting.vue?vue&type=script&lang=js"
export * from "./companychecksetting.vue?vue&type=script&lang=js"
import style0 from "./companychecksetting.vue?vue&type=style&index=0&id=06abcd1e&prod&scoped=true&lang=css"
import style1 from "./companychecksetting.vue?vue&type=style&index=1&id=06abcd1e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06abcd1e",
  null
  
)

export default component.exports